// MIT License - Copyright (c) 2026 Doug McNall

import React from 'react';
import { createPortal } from 'react-dom';
import './QuickReferenceModal.css';

/**
 * Quick Reference Modal
 * 
 * Keyboard shortcuts and quick reference guide
 */
const QuickReferenceModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const shortcuts = [
    { category: 'General', items: [
      { key: 'F1', action: 'Open Help' },
      { key: 'F2', action: 'Reputation Status' },
      { key: 'F3', action: 'Reset Game' },
      { key: 'ESC', action: 'Close Modal' },
    ]},
    { category: 'Navigation', items: [
      { key: '1', action: 'Universe Info' },
      { key: '2', action: 'Quick Jump' },
      { key: '3', action: 'Crew Management' },
      { key: '4', action: 'Cargo Bay' },
      { key: '5', action: 'Ship Naming' },
    ]},
    { category: 'Combat & Defense', items: [
      { key: '6', action: 'Shields/Upgrades' },
      { key: '7', action: 'Armory' },
      { key: '8', action: 'Cloak Toggle' },
      { key: '9', action: 'Countermeasures' },
      { key: '0', action: 'Mining' },
    ]},
    { category: 'Warp Controls', items: [
      { key: 'W', action: 'Increase Warp Factor' },
      { key: 'S', action: 'Decrease Warp Factor' },
      { key: 'SPACE', action: 'Engage/Disengage Warp' },
    ]},
  ];

  return createPortal(
    <div className="quick-ref-overlay" onClick={onClose}>
      <div className="quick-ref-modal" onClick={(e) => e.stopPropagation()}>
        <div className="quick-ref-header">
          <h2>⌨️ QUICK REFERENCE</h2>
          <button className="quick-ref-close" onClick={onClose}>✕</button>
        </div>

        <div className="quick-ref-content">
          {shortcuts.map((section, i) => (
            <div key={i} className="shortcut-section">
              <h3>{section.category}</h3>
              <div className="shortcut-list">
                {section.items.map((item, j) => (
                  <div key={j} className="shortcut-item">
                    <kbd className="shortcut-key">{item.key}</kbd>
                    <span className="shortcut-action">{item.action}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}

          <div className="quick-ref-tips">
            <h3>💡 Pro Tips</h3>
            <ul>
              <li>Higher warp factors consume more fuel but travel faster</li>
              <li>Reputation affects alien interactions and trade prices</li>
              <li>Cloak reduces encounter chance by 75%</li>
              <li>Countermeasures reduce encounter chance by 50%</li>
              <li>Mining and diplomacy minigames earn extra credits</li>
            </ul>
          </div>
        </div>

        <div className="quick-ref-footer">
          <button className="quick-ref-print" onClick={() => window.print()}>
            🖨️ Print Reference
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default QuickReferenceModal;
